<template>
  <footer>
    <ul>
      <li>debye.leong@gmail.com</li>
      <li class="logo">
        <img class="merry-go-round" src="../assets/img/logo/logo-white-130.png" alt="" aria-hidden="true" />
      </li>
      <li>linkedin.com/in/debyeleong/</li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped lang="scss">
@import '../assets/css/variables';

footer {
  @include top-diagonals(var(--diagonal-1x));
  ul {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    list-style: none;
    padding: var(--space-1x);
    height: 100%;
    width: 100%;
  }
  li {
    color: white;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: bold;
    padding: 0.25rem 0.5rem;
    &:last-child {
      padding-right: 0;
    }
    &.logo {
      display: none;
    }
  }

  @media screen and (min-width: $md) {
    li {
      &.logo {
        display: block;
      }
    }
  }
} // ~footer
</style>
